import React from 'react'
import PropTypes from 'prop-types'

import { Row, Col } from 'react-grid-system'

import styles from './styles.module.css'

const Header = ({ left, right, title, bordered }) => {
  return (
    <div className={styles.container}>
      <Row className="w-100" gutterWidth={0}>
        <Col xs={3} className="d-flex justify-content-start align-items-center">
          {right}
        </Col>
        <Col
          xs={6}
          className="d-flex justify-content-center align-items-center"
        >
          <h3 className={styles.title}>{title}</h3>
        </Col>
        <Col xs={3} className="d-flex justify-content-end align-items-center">
          {left}
        </Col>
      </Row>
    </div>
  )
}

Header.defaultProps = {
  left: <div></div>,
  title: '',
  right: <div></div>,
  bordered: false,
}

Header.propTypes = {
  left: PropTypes.object,
  title: PropTypes.string,
  right: PropTypes.object,
  bordered: PropTypes.bool,
}

export default Header
